import React, { Component } from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';
import InviteColleagues from '../common/InviteColleagues';
import { postRequest, deleteRequest } from '../../requestUtils';
import './ProjectPermissions.scss';

class ProjectPermissions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      invitedColleagues: props.invitedColleagues,
    };
    this.handleAddColleagues = this.handleAddColleagues.bind(this);
  }

  handleAddColleagues(addFeedbacks) {
    const updatedInvitedColleagues = addFeedbacks.team_members;
    this.setState({ invitedColleagues: updatedInvitedColleagues });
  }

  handleSendReminder(id, email, event) {
    const { csrfToken, projectResourceId } = this.props;
    const { target } = event;
    postRequest(
      `/projects/${projectResourceId}/project_permissions/${id}/reminder`,
      { email },
      csrfToken,
    ).then(() => {
      target.replaceWith(' Sent!');
    });
  }

  handleDelete(id) {
    const { csrfToken, projectResourceId } = this.props;
    deleteRequest(
      `/projects/${projectResourceId}/project_permissions/${id}`,
      csrfToken,
    ).then(() => {
      const { invitedColleagues } = this.state;
      const index = invitedColleagues.findIndex((elem) => elem.permissions_object_id === id);
      this.setState({ invitedColleagues: update(invitedColleagues, { $splice: [[index, 1]] }) });
    });
  }

  renderInvitedColleague(id, name, email, level) {
    return (
      <div className="invited-colleague body-text-2" key={`invited-${email}`}>
        <div className="medium-weight mb-2">{name || email}</div>
        <div className="muted-gray-text">
          {name ? email : 'Pending'}
          {!name
            && (
            <a
              tabIndex={0}
              role="button"
              className="ms-2"
              onClick={(e) => this.handleSendReminder(id, email, e)}
            >
              Send reminder
            </a>
            )}
          {id && level !== 'owner'
            && (
            <a
              tabIndex={0}
              role="button"
              className="ms-2"
              onClick={() => this.handleDelete(id)}
            >
              Remove
            </a>
            )}
        </div>
      </div>
    );
  }

  render() {
    const {
      csrfToken,
      resource,
      inviteUrl,
    } = this.props;
    const { invitedColleagues } = this.state;
    return (
      <div className="project-permissions">
        <div className="project-permissions-members">
          <i className="fa fa-users" />
          {invitedColleagues.length}
          {' '}
          member
          {invitedColleagues.length === 1 ? '' : 's'}
        </div>
        <InviteColleagues
          location="invoice View"
          invitedColleagues={invitedColleagues}
          uninvitedColleagues={[]}
          csrfToken={csrfToken}
          resource={resource}
          inviteUrl={inviteUrl}
          handleFeedbacks={this.handleAddColleagues}
          header="Invite new members"
          subtext="All members can view, export, approve and request changes on the timesheets of
          this project."
          messageHeader="Message"
          ownerMessagePlaceholder="Write a message to your colleagues"
          cta="Invite"
          submitCta="Send"
          showOwnerMessage
          modalClassName="project-permissions-modal"
          preventCloseModalAfterSubmit
        >
          <div className="colleagues style-guide">
            <h2>Members</h2>
            <div className="body-text-2 mt-3 mb-3">
              1 person must approve project timesheets within 5 days after the consultant
              submission.
            </div>
            <div className="invited-colleagues">
              {invitedColleagues.map((colleague) => (
                this.renderInvitedColleague(
                  colleague.permissions_object_id,
                  colleague.name,
                  colleague.email,
                  colleague.permissions_level,
                )
              ))}
            </div>
          </div>
        </InviteColleagues>
      </div>
    );
  }
}

ProjectPermissions.propTypes = {
  projectResourceId: PropTypes.string.isRequired,
  csrfToken: PropTypes.string,
  resource: PropTypes.string.isRequired,
  invitedColleagues: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  inviteUrl: PropTypes.string.isRequired,
};

ProjectPermissions.defaultProps = {
  csrfToken: '',
};

export default ProjectPermissions;
